import { getAnalysisRoute } from '@modules/bookmark/helpers';
import { getEmojiFromDashboard } from '@modules/dashboard/helpers';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { THEME_MODE_QUERY_PARAM, ThemeMode } from '@modules/theme/constants';
import { AnalysisViewFragment } from 'generated/graphql';
import { compressToEncodedURIComponent } from 'lz-string';
import { useGetDashboardSearchParamsForAnalysis } from './useGetDashboardSearchParamsForAnalysis';

export const useGetDashboardAnalysisLinkWithState = (
  analysis: AnalysisViewFragment,
  themeMode?: ThemeMode,
) => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);
  const dashboardContext = useDashboardStore(({ visual }) => visual.context);

  const dashboardName = dashboard.title;
  const dashboardEmoji = getEmojiFromDashboard(dashboard);

  const analysisRoute = getAnalysisRoute(analysis);

  const analysisLinkState = {
    dashboardName,
    dashboardEmoji,
    dashboardContext,
  };

  const dashboardAnalysisSearchParams = useGetDashboardSearchParamsForAnalysis({
    analysis,
    additionalParams: themeMode
      ? {
          [THEME_MODE_QUERY_PARAM]: themeMode,
        }
      : {},
  });

  return {
    analysisLink: `${analysisRoute}?${compressToEncodedURIComponent(
      dashboardAnalysisSearchParams,
    )}`,
    analysisLinkState: analysisLinkState,
  } as const;
};
